/* 
@example 
    
    export const ENDPOINT_ACTION_NAME = "/endpoint-url"
*/

//@dashboard count
export const NOTIFICATION_COUNT_URL = "/dashboard";

export const CREATE_NOTIFICATION_URL =
  "/lite/v2/api/admin/hospital/notify/nerve";

export const DELETE_NOTIFICATION_URL =
  "/lite/v2/api/admin/hospital/notify/nerve/";

//@ticket
export const TICKET_URL = "/lite/v2/api/v3/dashboard/complain";

// add dispatch
export const ADD_DISPATCH = "/lite/v2/api/admin/dispatch/add";

// UPDATE dispatch
export const UPDATE_DISPATCH_URL = "/lite/v2/api/admin/dispatch/update";

// disable dispatch
export const DISABLE_DISPATCH_URL = "/lite/v2/api/admin/dispatch/disable/";

// enable dispatch
export const ENABLE_DISPATCH_URL = "/lite/v2/api/admin/dispatch/enable/";

// add agent
export const FETCH_AGENT_URL = "/lite/v2/api/admin/agent/fetch/all";

// disable agent
export const DISABLE_AGENT_URL = "/lite/v2/api/admin/agent/disable/";

// disable agent
export const ENABLE_AGENT_URL = "/lite/v2/api/admin/agent/enable/";

// add agent
export const ADD_AGENT_URL = "/lite/v2/api/admin/agent/add";

// fetch hospitals
export const GET_HOSPITALS_URL = "/lite/v2/api/admin/hospital/list";

// fetch pipelines
export const GET_PIPELINES_URL = "/lite/v2/api/admin/pipeline/hospital";

// fetch notifications
export const GET_NOTIFICATION_URL = "/lite/v2/api/admin/hospital/notify/nerve/";

// UPDATE Hospital details
export const UPDATE_HOSPITAL_URL = "/lite/v2/api/admin/hospital/edit";

// fetch vendors
export const GET_VENDORS_URL = "/lite/v2/api/admin/vendor/list";

// cancel order
export const CANCEL_ORDER_URL = "/lite/v2/api/admin/order/cancel";

// premium list
export const PREMIUM_LIST_URL = "/lite/v2/api/admin/premium/list";

// admin dashboard count
export const DASHBOARD_URL = "/lite/v2/api/admin/dashboard";

// update ticket
export const UPDATE_TICKET_URL = "/lite/v2/api/admin/ticket/close";

// update ticket
export const RIDER_DETAILS_URL = "/lite/v2/api/admin/dispatch/tracker";

// get cylinder list
export const CYLINDER_LIST_URL = "/lite/v2/api/cylinder/landing";

export const CYLINDER_DETAILS_URL = "/lite/v2/api/cylinder/list/generated";

export const CYLINDER_SERIES_URL = "/lite/v2/api/cylinder/list/code/";

export const PLANTS_URL = "/lite/v2/api/cylinder/get/plant";

export const CYLINDERS_URL = "/lite/v2/api/cylinder/size/list";

export const ADD_CODE_URL = "/lite/v2/api/cylinder/code/generate";
// get cliams
export const GET_NERVE_CLAIM = "/lite/v2/api/admin/hospital/claim/nerve/";

export const SEND_NERVE_CLAIM =
  "lite/v2/api/admin/hospital/claim/reclaim/account/";

export const CRADLE_REQUEST = "/lite/v2/api/admin/crade/request";

export const CRADLE_UPDATE = "/lite/v2/api/admin/crade/request/accept";

export const INCIDENT_REPORT = "/lite/v2/api/admin/incident/report";

export const INCIDENT_REPORT_POST = "/lite/v2/api/admin/incident/report/treat";

export const NOTIFY_NERVE = "/lite/v2/api/admin/hospital/notify/nerve/";

export const NOTIFY_NERVE_POST = "/lite/v2/api/admin/hospital/notify/nerve";

export const DELETE_NERVE_POST = "/lite/v2/api/admin/hospital/notify/nerve/";

export const SHOW_ALL_PO = "/lite/v2/api/admin/po/list";

// export const SHOW_COHORT = "/lite/v2/api/admin/hospital/cohort";

export const SHOW_COHORT = "/lite/v2/api/admin/hospital/cohort/sent/list";

export const GET_ALL_MY_COHORT = `/lite/v2/api/admin/hospital/cohort`

export const ADD_HOSPITAL = "/lite/v2/api/admin/hospital/cohort/add/hospital";

export const CREATE_COHORT = "/lite/v2/api/admin/hospital/cohort/create";

export const ADD_HOSPITAL_COHORT ="/lite/v2/api/admin/hospital/cohort/add/hospital"

export const SHOW_COHORT_LIST = "/lite/v2/api/admin/hospital/cohort/list/";

export const SEND_COHORT = "/lite/v2/api/admin/hospital/cohort/send";

export const DELETE_COHORT = "/lite/v2/api/admin/hospital/cohort/delete/";

export const SEE_QUOTATION = "/lite/v2/api/admin/products/quotations";

export const SINGLE_QUOTATION = "/lite/v2/api/admin/products/quotations/single/";

export const SEND_QUOTATION = "/lite/v2/api/admin/quotations/send/"
